import React from 'react';
import Product from './Product';

interface ProductData {
    id: number;
    name: string;
    price: string;
    savings_price?: string;
    features?: string;
    trial?: boolean;
    product_name: string;
    tagline: string;
    savings: string;
    product_type?: string;
    stripe_plan: string;
}

interface ProductsProps {
    products: ProductData[];
    className?: string;
    productClassName?: string;
    form_authenticity_token?: string;
    user_signed_in?: boolean;
    loading?: boolean;
    onProductSelect?: (productId: number) => void;
}

const Products: React.FC<ProductsProps> = ({
    products,
    className = '',
    productClassName = '',
    form_authenticity_token,
    user_signed_in = false,
    loading = false,
    onProductSelect
}) => {
    // Validation
    if (!products || products.length === 0) {
        return (
            <div className="no-products-available">
                <div className="empty-state">
                    <i className="fa fa-shopping-cart fa-3x"></i>
                    <h3>No Products Available</h3>
                    <p>There are currently no products available for purchase.</p>
                </div>
            </div>
        );
    }

    if (loading) {
        return (
            <div className="products-loading">
                <div className="loading-spinner">
                    <i className="fa fa-spinner fa-spin fa-2x"></i>
                    <p>Loading products...</p>
                </div>
            </div>
        );
    }

    const handleProductClick = (productId: number) => {
        if (onProductSelect) {
            onProductSelect(productId);
        }
    };

    return (
        <div className={`products-container ${className}`.trim()}>
            <div className="products-grid">
                {products.map((product, index) => (
                    <div 
                        key={product.id || index} 
                        className={`product-wrapper ${productClassName}`.trim()}
                        onClick={() => handleProductClick(product.id)}
                    >
                        <Product
                            {...product}
                            form_authenticity_token={form_authenticity_token}
                            user_signed_in={user_signed_in}
                        />
                    </div>
                ))}
            </div>
            
            {products.length > 0 && (
                <div className="products-footer">
                    <div className="security-notice">
                        <i className="fa fa-shield-alt"></i>
                        <span>Secure payment processing</span>
                    </div>
                    <div className="support-info">
                        <i className="fa fa-question-circle"></i>
                        <span>Questions? <a href="/contact">Contact support</a></span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Products;
